export default [
    {
        // children: [
        //     {
        //         name: 'roleList',
        //         path: 'list',
        //         components: {
        //             list: () => import('@/views/organization/role/role.list'),
        //         },
        //     },
        //     {
        //         name: 'roleDetail',
        //         path: 'detail',
        //         components: {
        //             detail: () => import('@/views/organization/role/role.detail'),
        //         },
        //     }
        // ],
        // redirect: 'role/list'
        path: 'role',
        component: () => import('@/views/organization/role/role'),
    }
]